<template>
    <div
        class="numbers-group"
        :class="{promo8800: group.isUpsale}"
        data-element="numbers-group"
    >
        <div class="numbers-type_head">
            <h4 class="bold">
                {{ displayTitle }}
            </h4>
            <span
                class="stiker stiker--hit"
                data-element="demo-sticker"
                ref="sticker"
                :title="demoVatsStickerText"
                v-if="isDemoVats"
            >
                первые 14 дней бесплатно
            </span>
            <span
                class="stiker stiker--hit"
                data-element="discount-sticker"
                v-if="group.discount"
            >
                {{ group.discount.name }}
            </span>
            <template v-if="canBuy && canBuyMore">
                <a
                    href=""
                    class="dashed number-random"
                    :class="{active: chooseRandomDone}"
                    data-element="numbers-random-choice"
                    @click.prevent="chooseRandom"
                >
                    <template v-if="!chooseRandomDone">
                        <svg class="icon icon--shuffle">
                            <use xlink:href="#icon--shuffle"></use>
                        </svg>
                        <span class="choose">Выбрать случайный</span>
                    </template>
                    <template v-else>
                    <span class="chosen">
                        <i class="ui ui-check va-middle text-green"></i>
                        &nbsp;
                        <span class="dashed">Добавлено</span>
                    </span>
                    </template>
                </a>
            </template>
            <template v-else>
                <span
                    href=""
                    class="dashed number-random opacity-block"
                    data-element="numbers-random-choice"
                >
                    <svg class="icon icon--shuffle">
                        <use xlink:href="#icon--shuffle"></use>
                    </svg>
                    <span class="choose">Выбрать случайный</span>
                 </span>
            </template>

        </div>
        <div
            class="numbers-sel-tariff"
            data-element="tariff-select"
            v-if="isFMC && group.provider"
        >
            <span>Тариф:</span>
            &nbsp;
            <a href=""
               class="dashed"
               data-element="tariff-select-button"
               rel="nofollow"
               @click.prevent="showSelectTariffModal"
            >
                <span>{{ displaySelectTariff }}</span>
            </a>
            <img
                class="provider-img"
                :src="group.provider.logo"
                v-if="group.provider.logo"
            />
        </div>
        <p>
            <small class="footnote" data-element="numbers-block-desc">
                <template v-if="!showPrice">
                    Условия подключения, стоимость и абонентская плата - по запросу.
                </template>
                <template v-else>
                    Абонентская плата -
                    <span>
                        <strong :class="{'text-orange': showMonthlyDiscount}">
                            <s class="text-gray fs-sm price-old" data-element="regular-price-old" v-if="showMonthlyDiscount">{{ formatPrice(group.priceMonthlyFull) }}</s>
                            <span data-element="regular-price">{{ formatPrice(group.priceMonthly) }}</span>
                        </strong>
                        руб./месяц.
                    </span>
                    Подключение -
                    <span>
                        <strong :class="{'text-orange': showOnceDiscount}">
                            <s class="text-gray fs-sm price-old" data-element="connection-price-old" v-if="showOnceDiscount">{{ formatPrice(group.priceOnceFull) }}</s>
                            <span data-element="connection-price">{{ formatPrice(group.priceOnce) }}</span>
                        </strong>
                        руб./номер.
                    </span>
                </template>
            </small>
            <small class="footnote" v-if="is8800">
                Оформление номеров вида: 8 (800) 775-xxxx и 8 (800) 585-xxx возможно только на юридическое лицо!
            </small>
        </p>
        <div class="numbers-items">
            <template v-if="groupingCount > 0">
                <div class="numbers-items__items">
                    <div
                        class="numbers-items__block"
                        data-element="nums-block"
                        :key="key"
                        v-for="(items, key) in displayNumbers"
                    >
                        <NumbersBlock
                            :items="items"
                            :canBuy="canBuy"
                            :canBuyMore="canBuyMore"
                            :patterns="patterns"
                            :blockLoading="blockLoading"
                            @addNumbers="(numbers, blockId) => addNumbers(numbers, {blockId: blockId})"
                            @removeNumbers="(numbers, blockId) => removeNumbers(numbers, {blockId: blockId})"
                        />
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="numbers-items__items">
                    <div
                        class="numbers-items__item"
                        :key="item.id"
                        v-for="item in displayNumbers"
                    >
                        <NumberItem
                            :item="item"
                            :canBuy="canBuy"
                            :canBuyMore="canBuyMore"
                            :patterns="patterns"
                            @addNumber="(number) => addNumber(number)"
                            @removeNumber="(number) => removeNumber(number)"
                        />
                    </div>
                </div>
                <div class="numbers-items__more" v-if="!isLastPage && !hideShowMoreBtn">
                    <Button
                        title="Показать еще"
                        size="md"
                        :loading="loading"
                        @click="$emit('load')"
                    />
                </div>
            </template>
            <a
                data-type="link"
                class="numbers-items__register"
                data-toggle="modal"
                data-target=".js-modal-registration"
                v-if="showRegLink"
            >
                <span>
                    <b>Зарегистрируйтесь</b><br>чтобы увидеть больше номеров
                </span>
            </a>
        </div>
    </div>
</template>

<script>
import Button from '../../../components/ui/Button'
import NumbersBlock from './NumbersBlock'
import NumberItem from './NumberItem'
import SelectTariffModal from './SelectTariffModal';
import SelectTariffModalMobile from '../../numbers-page-mobile/components/SelectTariffModalMobile';
import ModelNumberGroup from '../models/number_group';
import ModelBranch from '../models/branch';
import ModelCategory from '../models/category';
import ModelCartItem from '../models/cart_item';
import priceFormatter from '../../../lib/priceFormatter.js'
import utils from '../../../lib/utils';
import ModelCart from "../models/cart";

/* global $ */

export default {
    name: "NumbersGroup",
    components: {
        NumbersBlock,
        NumberItem,
        Button
    },
    props: {

        // Мобильная версия
        isMobile: {
            type: Boolean,
            default: false
        },

        // Модель, описывающая группу номеров
        group: {
            type: ModelNumberGroup
        },

        // Модель, описывающая регион группы номеров
        branch: {
            type: ModelBranch
        },

        // Символьный код категории группы номеров
        category: {
            type: String
        },

        // Кейс покупки демо ВАТС
        isDemoVats: {
            type: Boolean,
            default: false
        },

        canBuyCount: {
            type: Number,
            default: 0
        },

        // Режим просмотра
        viewMode: {
            type: String,
            default: ''
        },

        // Кейс покупки FMC номера
        isFMC: {
            type: Boolean,
            default: false
        },

        isMVNO: {
            type: Boolean,
            default: false
        },

        // Количество номеров для группировки в блоки. 0 - группировка отключена.
        groupingCount: {
            type: Number,
            default: 0
        },

        // Количество выводимых номеров до показа ссылки на регистрацию
        // 0 - не выводить ссылку
        numbersCountBeforeRegLink: {
            type: Number,
            default: 0
        },

        // Индикатор загрузки страницы для данной группы номеров
        loading: {
            type: Boolean,
            default: false
        },

        // Индикаторы загрузки блоков
        blockLoading: {
            type: Object
        },

        // Массив шаблонов регулярных выражений для подсветки номеров
        patterns: {
            type: Array
        },

        hideShowMoreBtn: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            chooseRandomDone: false
        }
    },
    computed: {
        canBuyMore () {
            return !this.isDemoVats || this.canBuyCount > 0;
        },
        is8800 () {
            return this.group.is8800()
        },
        displayTitle () {
            if (this.is8800) {
                return '8-800 вся Россия';
            } else if (this.branch) {
                let title = this.branch.name;
                if (this.group.code) {
                    title += ' (' + this.group.code + ')';
                }
                return title;
            }
            return null;
        },
        displaySelectTariff () {
            if (this.group.selectedTariff) {
                return this.group.selectedTariff.name
            }
            return 'Выбрать'
        },
        demoVatsStickerText () {
            if (this.isDemoVats) {
                return `
                    <div style="text-align:left">В бесплатный период включено:
                        <ul>
                            <li>все возможности выбранной версии ВАТС</li>
                            <li>1 местный номер</li>
                            <li>100 минут на местные звонки и 1000 минут на sip</li>
                        </ul>
                    </div>
                `;
            }
            return null;
        },
        showPrice () {
            if (this.category === ModelCategory.constants.code.exclusive) {
                return false
            }
            if (!this.isFMC && !this.isDemoVats) {
                if (this.group.priceOnce === 0 && this.group.priceMonthly === 0 && !this.group.discount) {
                    return false
                }
            }
            return true
        },
        showMonthlyDiscount () {
            return this.group.priceMonthlyFull > this.group.priceMonthly
        },
        showOnceDiscount () {
            return this.group.priceOnceFull > this.group.priceOnce
        },
        canBuy () {
            return this.showPrice && this.viewMode !== 'readonly'
        },
        isLastPage () {
            return this.group.items.length >= this.group.nav.count
        },
        showRegLink () {
            return this.numbersCountBeforeRegLink > 0 && this.group.nav.count >= this.numbersCountBeforeRegLink && this.isLastPage
        },
        displayNumbers () {
            if (this.groupingCount > 0) {
                let blocks = [],
                    count = this.group.items.length;

                for (let i = 0; i < count; i += this.groupingCount) {
                    blocks.push(this.group.items.slice(i, i + this.groupingCount))
                }

                return blocks
            }
            return this.group.items
        },
        chooseRandomTitle () {
            return this.chooseRandomDone ? 'Добавлено' : 'Выбрать случайный'
        }
    },
    mounted () {
        if (this.isDemoVats) {
            $.Zebra_Tooltips($(this.$refs.sticker));
        }
    },
    methods: {
        formatPrice (price) {
            return priceFormatter.format(price)
        },
        addNumber (item, params) {
            this.addNumbers([item], params)
        },
        removeNumber (item, params) {
            this.removeNumbers([item], params);
        },
        addNumbers (items, params) {
            if (this.isFMC && this.group.provider && !this.group.selectedTariff) {
                this.showSelectTariffModal(() => {
                    this.addNumbers(items, params)
                });
                return;
            }

            let type = this.isFMC ? ModelCart.constants.type.fmcNumbers : ModelCart.constants.type.numbers;
            if (this.isMVNO) {
                type = ModelCart.constants.type.mvnoNumbers;
            }

            let cartItems = items.map(item => ModelCartItem.createFromNumber(item, this.group, type));
            this.$emit('addNumbers', cartItems, params);
            let resizeEvent = new Event('resize');
            window.dispatchEvent(resizeEvent);
        },
        removeNumbers (items, params) {
            let type = this.isFMC ? ModelCart.constants.type.fmcNumbers : ModelCart.constants.type.numbers;
            if (this.isMVNO) {
                type = ModelCart.constants.type.mvnoNumbers;
            }

            let cartItems = items.map(item => ModelCartItem.createFromNumber(item, this.group, type));
            this.$emit('removeNumbers', cartItems, params);
        },
        chooseRandom () {
            if (this.chooseRandomDone) {
                return;
            }
            let items = this.group.items.filter(item => !item.selected);
            let l = items.length;
            if (l === 0) {
                return;
            }
            let item = items[Math.floor(Math.random() * l)];
            this.addNumber(item, {chooseRandomCallback: () => {
                    this.chooseRandomDone = true;
                    setTimeout(() => {
                        this.chooseRandomDone = false;
                    }, 1000)
                }});
        },
        showSelectTariffModal (callback) {
            let modal = SelectTariffModal;

            if (this.isMobile) {
                modal = SelectTariffModalMobile;
            }

            this.$modal.show(modal, {
                provider: this.group.provider,
                tariffs: this.group.tariffs,
                selectedTariff: this.group.selectedTariff,
                selectTariffFunction: (tariff) => {
                    this.group.selectedTariff = tariff;
                    this.$emit('changeProviderTariff', this.group.provider, tariff);
                    if (utils.isFunction(callback)) {
                        callback.apply(this)
                    }
                }
            }, {
                scrollable: true,
                width: this.isMobile ? '100%' : 600,
                height: 'auto'
            });
        }
    }
}
</script>

<style lang="scss">
.numbers-type_block {

    .stiker {
        margin-right: 4px;
    }
}

.numbers-group {
    margin-bottom: 30px;

    &.promo8800 {
        padding: 20px;
    }

    .price-old {
        margin-right: 5px;
    }
}

.numbers-items {
    margin-top: 20px;

    .numbers-item {
        margin: 0;

        &.disabled {
            padding-left: 8px;
        }

        u {
            color: #37474f;
            text-decoration: none;
        }
    }

    &__items {
        display: flex;
        flex-flow: row wrap;
        margin: 0 -6px;
    }

    &__item {
        padding: 0 6px;
        margin-bottom: 10px;
    }

    &__block {
        padding: 0 6px;
        margin-bottom: 24px;
    }

    @media (min-width:640px) {

        &__item {
            width: 33.3333%;
        }

        &__block {
            width: 33.3333%;
        }
    }

    @media (min-width:1366px) {

        &__item {
            width: 25%;
        }

        &__block {
            width: 25%;
        }
    }

    &__more {
        margin-top: 20px;
        text-align: center;
    }

    &__register {
        display: block;
        position: relative;
        margin: 20px auto;
        max-width: 300px;
        height: 75px;
        line-height: 75px;
        font-size: 13px;
        background: #ff6500;
        background-image: linear-gradient(to right,#ff6500,#ff0065);
        color: #ffffff;
        border-radius: 3px;

        &:hover {
            color: #ffffff;
        }

        span {
            display: inline-block;
            padding: 10px 15px;
            width: 100%;
            vertical-align: middle;
            line-height: 23px;
            text-align: center;

            b {
                font-size: 18px;
                font-weight: 500;
            }
        }
    }
}

.numbers-block {
    position: relative;
    padding: 5px;
    min-width: 170px;
    border: 1px solid #cddbe3;
    border-radius: 3px;

    .numbers-item {
        display: block;
        width: auto;
        padding: 0 5px 0 35px;
        margin: 0 -5px 5px;
    }

    &__head {
        position: relative;
        font-size: 12px;
        color: #667c84;
        margin-left: 5px;
    }

    &__all {
        display: none;

        @media (min-width:1366px) {
            display: block;
            position: absolute;
            top: 0;
            right: 0;
        }
    }

    &__ribbon {
        display: inline-block;
        position: relative;
        margin: 0 0 10px -5px;
        padding: 0 .6em 0 10px;
        background-color: #e5edf3;
        color: #607d8b;
        line-height: 1.8;
        font-size: 70%;
        font-weight: 100;

        &:before {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            right: -.7em;
            width: 1em;
            background: inherit;
            clip-path: polygon(0 110%,100% 110%,30% 50%,110% -10%,0 0);
        }
    }
}
.opacity-block {
    opacity: 0.5;
    cursor: default;
}
</style>